// extracted by mini-css-extract-plugin
export var heroImage = "_c6-1";
export var modal = "_c6-0";